import { mobileNavItems } from '../../routes/routes';
import NavLink from './NavLink';

function MobileTabBar({ activePath }) {
  return (
    <nav className="mobile-tabbar" aria-label="하단 메뉴">
      {mobileNavItems.map((item) => (
        <NavLink key={item.id} item={item} isActive={activePath === item.path} />
      ))}
    </nav>
  );
}

export default MobileTabBar;
